export { color } from "@rimo/ui-old";
